import pages, { PageInstance } from '@/config/page'
import { RouteRecordRaw } from 'vue-router'

const configRoutes = genConfigRoutes(pages)

const otherRoutes: RouteRecordRaw[] = [
  {
    path: '/limite-time-event',
    name: 'limite-time-event',
    component: () => import('@/views/pages/notice/limite-time-event/index.vue')
  },
  {
    path: '/attachment/preview',
    name: 'attachment-public-preview',
    meta: { public: true },
    component: () => import('@/views/pages/attachment-public-preview/index.vue')
  },
  {
    path: '/share/market-intelligence',
    name: 'market-intelligence-public',
    component: () => import('@/views/pages/share/market-intelligence-public/index.vue')
  },
  {
    path: '/share/market-intelligence-insight',
    name: 'market-intelligence-insight-public',
    component: () => import('@/views/pages/share/market-intelligence-insight-public/index.vue')
  }
]

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/views/layout/index.vue'),
    // redirect: '/org/company/detail',
    meta: { pid: '/' },
    children: [...configRoutes]
  },
  // DON'T CHANGE BELOW
  {
    path: '/error/:code',
    name: 'error',
    props: ({ params = {} }) => ({ ...params }),
    component: () => import('@/views/error/index.vue')
  },
   {
    path: '/success',
    name: 'success',
    props: ({ params = {} }) => ({ ...params }),
    component: () => import('@/views/error/success.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/reset-pwd',
    name: 'reset-pwd',
    component: () => import('@/views/reset-pwd/index.vue')
  },
   ...otherRoutes,
  {
    path: '/:pathMatch(.*)*',
    redirect: '/error/404'
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: () => import('@/views/pages/onboarding/index.vue'),
    children: [
      {
        path: 'auto-kyc',
        name: 'auto-kyc',
        component: () => import('@/views/pages/onboarding/auto-kyc/index.vue')
      }
    ]
  },
  {
    path: '/faq/:category/:id/:page',
    name: 'faq',
    component: () => import('@/views/freshchat/faq.vue')
  },
  {
    path: '/faqs/:id',
    name: 'faqs',
    component: () => import('@/views/freshchat/faqs.vue')
  },
  {
    path: '/calculation',
    name: 'calculation',
    component: () => import('@/views/pages/deal-channel-partner/calculation-company/index.vue')
  }
]

// console.info('routes: ', routes)

export default routes

function genConfigRoutes(pages: PageInstance[]): RouteRecordRaw[] {
  return traverse(pages)

  function traverse(pages: PageInstance[], parent?: RouteRecordRaw): RouteRecordRaw[] {
    const ret: RouteRecordRaw[] = []
    pages.forEach(v => {
      let item
      if (v.type.includes('router')) {
        item = {
          path: v.router?.path || v.path,
          name: v.router?.name || v.path,
          props: ({ params = {}, query = {} }) => ({ ...params, ...query }),
          component: () => import(`@/views/pages${v.path}/index.vue`),
          meta: { pid: v.pid || v.path, page: v },
          redirect: v.router?.redirect
        }
        if (v.router?.nested && parent) {
          if (!parent.children) parent.children = []
          parent.children.push(item)
        } else {
          ret.push(item)
        }
      }
      const children = Array.isArray(v.children) && v.children.length > 0 ? traverse(v.children, item) : []
      if (children.length > 0) ret.push(...children)
    })
    return ret
  }
}
